<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
               <form @submit.prevent="saveCampaign">
                   <div class="form-group">
                       <label for="siteSelect">
                           Participating Site
                       </label>
                       <div class="text-danger" v-if="campaignToSave.siteIds.hasError">
                           {{ campaignToSave.siteIds.errorMessage}}
                       </div>
                       <div class="form-check" v-for="site in sites">
                           <input class="form-check-input" type="checkbox" value="site.siteId" :checked="site.isChecked" :id="'siteCheckbox' + site.siteId"
                                @change="onSiteCheck($event, site)"/>
                           <label class="form-check-label" :for="'siteCheckbox' + site.siteId">
                               {{site.siteName}}
                           </label>
                       </div>
                   </div>
                   <div class="form-group">
                       <label for="campaignNameInput">
                           Campaign Name
                       </label>
                       <div class="text-danger" v-if="campaignToSave.campaignName.hasError">
                           {{ campaignToSave.campaignName.errorMessage}}
                       </div>
                       <input type="text" class="form-control" id="campaignNameInput" v-model="campaignToSave.campaignName.value"/>
                   </div>
                   <div class="form-group">
                       <label>Start Date</label>
                       <div class="text-danger" v-if="campaignToSave.startDate.hasError">
                           {{campaignToSave.startDate.errorMessage}}
                       </div>
                       <date-picker :format="'dd/MM/yyyy'" :elementId="'startDatePicker'" :date="campaignToSave.startDate.value"
                                    :initialiseDate="initialiseActiveFromDate"
                                    @dateChange="onActiveStartDateSelect"></date-picker>
                   </div>
                   <div class="form-group">
                       <label>End Date</label>
                       <div class="text-danger" v-if="campaignToSave.endDate.hasError">
                           {{campaignToSave.startDate.errorMessage}}
                       </div>
                       <date-picker :format="'dd/MM/yyyy'" :elementId="'endDatePicker'" :date="campaignToSave.endDate.value"
                                    :initialiseDate="initialiseActiveToDate"
                                    @dateChange="onActiveEndDateSelect"></date-picker>
                   </div>
                   <div class="form-group">
                       <label>
                           Banner
                       </label>
                       <div class="custom-file">
                           <input type="file" class="custom-file-input" id="bannerImageInput" @change="onBannerImageAttach"
                                  accept="image/png, image/jpeg">
                           <label class="custom-file-label" for="bannerImageInput" v-if="campaignToSave.bannerImage === null">
                               Choose file
                           </label>
                           <label class="custom-file-label" for="bannerImageInput" v-if="campaignToSave.bannerImage !== null">
                               {{campaignToSave.bannerImage.name}}
                           </label>
                       </div>
                       <p>Images cannot exceed 2MB. Recommended dimensions: 1920px x 648px</p>
                       <button class="btn btn-link" v-if="campaignToSave.bannerExistsForCampaign && isEdit" @click.prevent="downloadBannerForCampaign">
                           View Banner Image
                       </button>
                   </div>
               </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="saveCampaign" :disabled="formIsSaving">Save</button>
                <button type="button" class="btn btn-secondary" @click="onModalCloseClick" :disabled="formIsSaving">Close</button>
            </div>
        </div>
    </div>
</div>